import React from 'react';
import styled from 'styled-components';

const Card = styled.div`
  background: #FFFAF5;
  border-radius: 16px;
  padding: 1.5rem;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.05);
`;

const Title = styled.h2`
  color: #FF7C24;
  font-size: 20px;
  margin-bottom: 1rem;
`;

const Stat = styled.div`
  font-size: 28px;
  font-weight: bold;
  color: #232830;
  margin-bottom: 1rem;
`;

const ChannelList = styled.ul`
  list-style: none;
  padding: 0;
  margin-top: 1rem;
`;

const ChannelItem = styled.li`
  font-size: 16px;
  margin-bottom: 0.5rem;
  color: #232830;
`;

export default function AcquisitionCard({ userData }) {
  let totalSignups = 0;

  const channelBreakdown = userData.reduce((acc, user) => {
    let rawChannel = user.channel;
    let channel = '';

    if (!rawChannel || rawChannel.trim() === '') {
      // 🔸 If channel missing or empty, classify as iOS
      channel = 'ios';
    } else {
      channel = rawChannel.toString().trim().toLowerCase();
    }

    // 🔹 Classify and count
    if (channel === '1' || channel === 'web') {
      acc.web = (acc.web || 0) + 1;
    } else if (channel === '2' || channel === 'android') {
      acc.android = (acc.android || 0) + 1;
    } else if (channel === 'ios') {
      acc.ios = (acc.ios || 0) + 1;
    } else {
      acc.unknown = (acc.unknown || 0) + 1;
    }

    totalSignups++;
    return acc;
  }, {});

  return (
    <Card>
      <Title>Acquisition</Title>
      {/* // Acquisition  */}
     
      <Stat>{totalSignups} Signups</Stat>
      <ChannelList>
        <ChannelItem>Web: {channelBreakdown.web || 0}</ChannelItem> 
     
        
        <ChannelItem>iOS: {channelBreakdown.ios || 0}</ChannelItem>
        <ChannelItem>Android: {channelBreakdown.android || 0}</ChannelItem>
        <ChannelItem>Unknown: {channelBreakdown.unknown || 0}</ChannelItem>
      </ChannelList>
    </Card>
  );
}
